<script>
  import { ignore, getCollapseClass } from "../../Common/tools";
  import Slider from "../../Common/Slider.svelte";
  import FilePicker from "../../Common/FilePicker.svelte";
  import LinkPicker from "../../Common/LinkPicker.svelte";
  import BlockGlobal from "./BlockGlobal.svelte";
  import {M} from "../../external";
  import Checkbox from '../../Common/Checkbox.svelte';

  export let data,
    onChange = ignore,
    disable = [],
    label = M.IMAGE,
    isCollapsable = false,
    isCollapsed = false;

  const onComplete = (base, file) => {
    data = Object.assign({}, data, { base: base, file: file });
  }

  const onLinkSelected = (value) => {
    data = Object.assign({}, data, { link: value.link });
  }

  const toggleCollapse = () => {
    if (isCollapsable) {
      isCollapsed = !isCollapsed;
    }
  }
</script>

<div class="col20 f-left t-center mb-25 mt-15" on:click={toggleCollapse}><h4 class="t-left {getCollapseClass(isCollapsable, isCollapsed)}">{label}</h4></div>
{#if !isCollapsed}
  <div class="col20 f-left">
    <Checkbox
      bind:data={data.hideLogo}
      label={M.DONT_SHOW_LOGO}
      clz="f20" />
  </div>
  {#if !data.hideLogo}
    <div class="section">
      {#if disable.indexOf("width") === -1}
        <Slider
          min={10}
          max={500}
          value={data.style.width || 139}
          clz="mt-5"
          showValue={false}
          sameLine={true}
          onChange={(val) => onChange("width", val)}
          label={M.IMAGE_WIDTH} />
      {/if}
      {#if disable.indexOf("align") === -1}
        <div class="popup-input-wrapper input-slider-wrapper mt-5">
          <h5 class="inline">{M.IMAGE_ALIGN}</h5>
          <select bind:value={data.style.position}>
            <option value="left">{M.LEFT}</option>
            <option value="center">{M.CENTER}</option>
            <option value="right">{M.RIGHT}</option>
          </select>
        </div>
      {/if}
      <div class="info">
        <span>{M.IMAGE}</span>
      </div>
      <div class="right-side">
        <FilePicker bind:file={data.file} config={{ placeholder: M.SELECT_IMAGE, imagesOnly: true }} onComplete={onComplete} />
      </div>
      <div class="info">
        <span>URL</span>
      </div>
      <div class="right-side">
        <LinkPicker config={data} onComplete={onLinkSelected} emailLinkPicker={true} />
      </div>
    </div>
  {/if}
{/if}
<BlockGlobal bind:data disable={disable} isCollapsable={true} isCollapsed={true} />
